import Platform from "./Platform";
export default Platform;